import { DateTime } from 'luxon';
export default function episodesThroughLens(this: any): any[] {
  if (this.feedData && this.feedData.loaded && this.feedData.episodes) {
    return this.feedData.episodes.map((episode: any) => {
      const episodeDateInMillis = episode.dateTime.toMillis();
      const tooOld = episodeDateInMillis < this.initialTimeMS;
      let newDateTime = null;
      if (this.initialTimeMS && this.startTimeMS) {
        // Can do the scaling things
        const newTimeInMillis = ((episodeDateInMillis - this.initialTimeMS) / this.speedup)
          + this.startTimeMS;
        newDateTime = DateTime.fromMillis(newTimeInMillis);
      }
      return {
        ...episode,
        newDateTime,
        tooOld,
      };
    });
  } else {
    return [];
  }
}
